import { Control, Controller } from 'react-hook-form'

import { TextField } from '@mui/material'
import { Video } from 'features/videos/service'

type Props = {
  control: Control<Video>
}

export const SlugController = ({ control }: Props) => {
  return (
    <Controller
      control={control}
      defaultValue={''}
      name={'slug'}
      render={({ field, fieldState }) => {
        let helperText = ''

        if (fieldState.error) {
          if (fieldState.error.type === 'required') {
            helperText = 'Slug обязателен для видео в публичных курсах'
          } else {
            helperText = 'Максимальная длина 50 символов'
          }
        }

        return (
          <TextField
            error={!!fieldState.error}
            fullWidth
            helperText={helperText}
            label={'Slug'}
            style={{ marginTop: '10px' }}
            {...field}
          />
        )
      }}
      rules={{ maxLength: 50 }}
    />
  )
}
